const realizzazioni = () => {
  const wrapper = document.querySelector(".realizzazioni");
  if (!wrapper) return;

  const results = wrapper.querySelector(".realizzazioni__results");
  const buttons = wrapper.querySelectorAll(".filter__button");
  if (!results || !buttons.length) return;

  const { action, nonce, lang } = wrapper.dataset;

  const filterBy = (term, target) => {
    // Single selection (non cumulative)
    buttons.forEach((b) => b.classList.remove("is-active"));
    target.classList.add("is-active");

    results.classList.add("is-loading");

    $.ajax({
      type: "POST",
      dataType: "json",
      url: ajax_auth_object.ajaxurl,
      data: {
        action: action,
        nonce: nonce,
        term: term,
        lang: lang,
      },
      success: (response) => {
        if (response && response.success) {
          results.innerHTML = response.data.html;
        }
      },
      complete: () => {
        results.classList.remove("is-loading");
      },
    });
  };

  buttons.forEach((button) => {
    button.addEventListener("click", () => {
      if (button.classList.contains("is-active")) return;
      filterBy(button.dataset.term || "", button);
    });
  });
};

export default realizzazioni;
